// extracted by mini-css-extract-plugin
export default {"adminApp":"AdminApp_adminApp__M8oUu"};